import { useContext, useEffect, useState } from "react";
import AddressIcon from "./Images/icon_address.svg";
import DeleteIcon from "./Images/icon_deletecon.svg";
import LogoutIcon from "./Images/icon_logout.svg";
import OrdersIcon from "./Images/icon_orders.svg";
import PasswordIcon from "./Images/icon_password.svg";
import RecoveryIcon from "./Images/icon_recovery.svg";
import UserIcon from "./Images/icon_user.svg";
import WalletIcon from "./Images/icon_wallet.svg";
import PiontIcon from "./Images/piont.svg";
import HeartIcon from "./Images/Heart.svg";
import { ProfileContext } from "./Profile";
// import { Cookies } from 'react-cookie'
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import * as main_category from "../../network/api/maincategory";
import { useTranslation } from "react-i18next";
function Sidebar({ getUserName }) {
  // const cookie = new Cookies()
  const token = Cookies.get("user");
  const [id, setid] = useState("");
  useEffect(() => {
    main_category
      .getcategories()
      .then((result) => {
        const firstId = result?.data?.response?.[0]?._id;
        if (firstId) setid(firstId);
      })
      .catch(() => {
        // no-op
      });
  }, []);
  const navigate = useNavigate();
  const { tabChosen, setTabChosen } = useContext(ProfileContext);
  const { openModelHandler } = useContext(ProfileContext);
  const { t } = useTranslation();
  return (
    <div className="sidebar d-none d-lg-block">
      <ul className="tabs">
        <li className={`${tabChosen === "user" || tabChosen === 'address' || tabChosen === 'password' || tabChosen === 'delete' ? "chosen account" : ""} mb-2 `}
        > <img src={UserIcon} alt="" /><span>{t("Account")}</span>
        </li>
        <li className={`${tabChosen === "user" ? "chosen" : ""} me-5`} style={{ listStyle: 'disc' }}
          onClick={() => setTabChosen("user")}
        > {tabChosen === 'user' ?
          <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="3" fill="#C99700" />
          </svg>
          :
          <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="3" fill="#807D7E" />
          </svg>
          }
          <span className="me-2">{t("Account")}</span>
        </li>
        <li
          className={`${tabChosen === "address" ? "chosen" : ""}  me-5`}
          onClick={() => setTabChosen("address")}
        >{tabChosen === 'address' ?
          <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="3" fill="#C99700" />
          </svg>
          :
          <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="3" fill="#807D7E" />
          </svg>
          }
          <span className="me-2">{t("Addresses")}</span>
        </li>
        <li
          className={`${tabChosen === "password" ? "chosen" : ""}  me-5`}
          onClick={() => setTabChosen("password")}
        >{tabChosen === 'password' ?
          <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="3" fill="#C99700" />
          </svg>
          :
          <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="3" fill="#807D7E" />
          </svg>
          }
          <span className="me-2">{t("ChangePassword")}</span>
        </li>
        <li
          className={`${tabChosen === "delete" ? "chosen" : ""}  me-5`}
          onClick={() => setTabChosen("delete")}
        >
          <button
            style={{
              backgroundColor: "#00000000",
              border: "none",
              color: "#807D7E",
            }}
            onClick={() => {
              openModelHandler(true);
            }}
          >
            {" "}
            <img src={DeleteIcon} alt="" style={{ width: '14px' }} /> <span>{t("DeleteAccount")} </span>
          </button>
        </li>
        <li
          className={`${tabChosen === "orders" ? "chosen" : ""}`}
          onClick={() => setTabChosen("orders")}
        >
          <img src={OrdersIcon} alt="" /> <span>{t("MyOrders")}</span>
        </li>
        <li
          className={`${tabChosen === "wishlist" ? "chosen" : ""}`}
          onClick={() => setTabChosen("wishlist")}
        >
          <img src={HeartIcon} alt="" /> <span>{t("wishlist")}</span>
        </li>
        <li
          className={`${tabChosen === "recovery" ? "chosen" : ""}`}
          onClick={() => setTabChosen("recovery")}
        >
          <img src={RecoveryIcon} alt="" /> <span>{t("Returns")}</span>
        </li>
        <li
          className={`${tabChosen === "wallet" ? "chosen" : ""}`}
          onClick={() => setTabChosen("wallet")}
        >
          <img src={WalletIcon} alt="" /> <span>{t("MyWallet")}</span>
        </li>
        <li
          className={`${tabChosen === "pionts" ? "chosen" : ""}`}
          onClick={() => setTabChosen("pionts")}
        >
          <img src={PiontIcon} alt="" /> <span>{t("MyPionts")}</span>
        </li>

        <li
          className={`${tabChosen === "logout" ? "chosen" : ""}`}
          onClick={() => setTabChosen("logout")}
        >
          <button
            style={{
              backgroundColor: "#00000000",
              border: "none",
              color: "#807D7E",
            }}
            onClick={async () => {
              Cookies.remove("user");
              Cookies.remove("mycart");
              Cookies.remove("mywish");
              navigate("/");
              window.location.reload();
            }}
          >
            {" "}
            <img src={LogoutIcon} alt="" /> <span>{t("LogOut")}</span>
          </button>
        </li>

      </ul>
    </div>
  );
}
export default Sidebar;
